import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { AdvertListFilterItem } from '@edikk-edikk/country-frontend';
import contentItemCss from '#srcCssModules/advert/list-filter/advert-list-filter-content-item.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

type PropsType = {
  filterItem: AdvertListFilterItem;
};

const FilterItemDetail: FC<PropsType> = ({
  filterItem,
}) => {
  const { onChangeSubject } = useFilterContext();

  return (
    <Button
      variant={ButtonVariant.unstyled}
      navLinkProps={{
        to: filterItem.url,
        state: { routerConfig: filterItem.routerConfig.getData() },
        end: true,
        onClick: () => {
          onChangeSubject.next(filterItem.url);
        },
        className: contentItemCss.advertListFilterContentItem,
        activeClassName: contentItemCss.advertListFilterContentItem_active,
      }}
    >
      <div className={contentItemCss.advertListFilterContentItem__content}>
        <div>
          {filterItem.getVisibleName()}
        </div>
        <div className={contentItemCss.advertListFilterContentItem__counter}>
          (
          {filterItem.numberOfAdverts}
          )
        </div>
      </div>
    </Button>
  );
};

export { FilterItemDetail };
